module.exports = __webpack_public_path__ + "media/images/flags/16/Slovakia-3aa08db6c6b08e244bfa95b376142083.png";